<template>
    <rkm-modal
        extraLarge
        ref="RkmModalExames"
        title="Confirmação do agendamento retroativo"
        v-if="pacienteExists"
    >
        <rkm-alert show info>
            <strong>
                {{itemSelecionado.data}} -
                {{ getStringDiaSemana(itemSelecionado.semanaId) }}
            </strong>
        </rkm-alert>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-form-input
                    label="Nome paciente"
                    v-model="data.form.paciente.cidadao.nome"
                    disabled
                />
            </rkm-col>
            <rkm-col cols="6">
                <rkm-form-input
                    label="Unidade executante"
                    v-model="itemSelecionado.unidadeNome"
                    disabled
                />
            </rkm-col>
            <rkm-col cols="6">
                <rkm-form-input
                    label="Local de atendimento"
                    v-model="itemSelecionado.infraestruturaNome"
                    disabled
                />
            </rkm-col>
            <rkm-col cols="6">
                <rkm-form-input
                    label="Profissional"
                    v-model="itemSelecionado.profissionalNome"
                    disabled
                />
            </rkm-col>
            <rkm-col cols="6">
                <rkm-form-input
                    label="Grupo de exame"
                    v-model="itemSelecionado.exameNome"
                    disabled
                />
            </rkm-col>
        </rkm-row>

        <Form
            ref="Form"
            :data="data"
             :jornadas="jornadas"
            :agendamento="agendamento"
            :itemSelecionado="itemSelecionado"
            :vagas="vagas"
            :vagasPreenchidas="vagasPreenchidas"
            :checkAuthorization="checkAuthorization"
            :horaSave="horaSave"
            @handleCadastro="handleCadastro"
            @horariosDisponiveis="handleHorariosDisponiveis"
        />

        <ModalPermissao
            ref="RkmModalPermissao"
            @saveModal="saveModal"
            :origem="origem"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">
              Voltar
            </rkm-button>
            <rkm-button
                @click.stop="confirmar"
                color="primary"
            >
                {{ agendamento.alterar == true ? 'Alterar agendamento' : 'Confirmar' }}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>

// Mixins.
import { error, repository } from '@/mixins'

//Enums
import tipoJornada from '@/enums/exame-imagem/tipoJornada'
import diasSemana from '@/enums/exame-imagem/diasSemana'
import tipoControleJornada from '@/enums/exame-imagem/tipoControleJornada'
import tipoCota from '@/enums/exame-imagem/tipoCota'

//Components.
import Form from '@/components/exame-imagem/agendamento-retroativo/tabs/cadastro/components/exames/Form'
import ModalPermissao from '@/components/exame-imagem/agendamento/tabs/cadastro/components/permissao/Modal'

// Filters.
import formats from '@/filters/formats'

// Moment.
import moment from 'moment'

export default {
    components: { Form, ModalPermissao },
    computed: {
        pacienteExists() {
            return this.data.form && this.data.form.paciente
        },
    },
    data: () => ({
        origem: 'exame',
        checkAuthorization: false,
        autoriza: false,
        index: null,
        item: null,
        itemSelecionado: [],
        diaSelecionado: [],
        horarioAtendimento: null,
        enums: {
            tipoJornada,
            diasSemana,
            tipoControleJornada,
            tipoCota
        },
        vagasPreenchidas: 0,
        exames: [],
        verificaHorario: false,
        verificaVagas: false,
        jornada: null,
        cotas: [],
        handleData: []
    }),
    filters: {
        ...formats,
    },
    methods: {
        open(itemSelecionado, diaSelecionado, vagasPreenchidas, notAuthorized) {

            if(notAuthorized == false){

                this.checkAuthorization = true
            }

            this.diaSelecionado = diaSelecionado

            this.itemSelecionado = itemSelecionado

            this.vagasPreenchidas = Number(vagasPreenchidas)

            this.$refs.RkmModalExames.show()
        },
        handleCadastro(value, hora, autoriza){

            const verificaJornada = this.jornadas.find(item => item.data == this.itemSelecionado.data
                && item.profissionalId == this.itemSelecionado.profissionalId
                && item.horaInicial <= hora && item.horaFim >= hora)

            this.exames = value

            this.horarioAtendimento = hora

            this.autoriza = autoriza

            this.jornada = verificaJornada.jornadaId
        },
        handleHorariosDisponiveis(horarios){

            this.horariosDisponiveis = horarios
        },
        confirmar(){

            if(this.agendamento.alterar == true){

                if(this.horarioAtendimento == null){

                    this.showValidationNotification('Obrigatório selecionar um horário.')
                    return false
                }

            } else {

                if (this.exames.length == 0 && this.horarioAtendimento == null && this.agendamento.horaExame == '') {

                    this.showValidationNotification('Obrigatório selecionar um horário.')

                    return false

                } else if (this.horarioAtendimento == null || this.horarioAtendimento == undefined) {

                    if (!this.horariosDisponiveis.find(horario => horario.value == this.horarioAtendimento)) {

                        this.showValidationNotification('Obrigatório selecionar um horário.')
                        return false
                    }
                } else if (this.agendamento.horaInicial != null) {

                    if (!this.horariosDisponiveis.find(horario => horario.value == this.agendamento.horaInicial)) {

                        this.showValidationNotification('Obrigatório selecionar um horário.')
                        return false
                    }
                }
            }

            if (this.exames.length == 0 && this.agendamento.incluido.length == 0){

                this.showValidationNotification('Obrigatório atribuir pelo menos um exame no agendamento.')
                return false

            }

            if(this.itemSelecionado.controleJornadaId == this.enums.tipoControleJornada.ATENDIMENTO){

                this.jornadas.filter(item => moment(item.data, 'DD/MM/YYYY').format('YYYY-MM-DD') == moment(this.itemSelecionado.data, 'DD/MM/YYYY').format('YYYY-MM-DD')
                    && item.horaInicial <= this.horarioAtendimento && item.horaFim >= this.horarioAtendimento
                    && item.profissionalId == this.itemSelecionado.profissionalId).map(verificaTipo => {

                        if(verificaTipo.tipoId == this.enums.tipoJornada.DINAMICA){

                            this.verificaVagas = false

                            this.verificaHorario = false

                            this.vagas.filter(item => item.horaExame === this.horarioAtendimento
                                && item.data == this.itemSelecionado.data)
                                .map(dinamico => {

                                    if(dinamico){

                                        this.verificaHorario = true
                                    }
                                })

                        } else {

                            this.jornadas.filter(item => moment(item.data, 'DD/MM/YYYY').format('YYYY-MM-DD') == moment(this.itemSelecionado.data, 'DD/MM/YYYY').format('YYYY-MM-DD')
                                && item.profissionalId == this.itemSelecionado.profissionalId
                                && item.horaInicial === this.horarioAtendimento).map(fixo => {

                                    let vagasPreenchidas = 0

                                    this.verificaHorario = false

                                    if(this.exames){

                                        this.verificaHorario = false
                                    }

                                    this.vagas.filter(item => {

                                        if(item.horaExame === this.horarioAtendimento && item.data === fixo.data){

                                            vagasPreenchidas = vagasPreenchidas + 1
                                        }
                                    })

                                    let vagas = Number(fixo.vagas || 0) + Number(fixo.vagasApp || 0)

                                    const vagasDisponiveis = vagas - vagasPreenchidas

                                    if(vagasDisponiveis <= 0 && this.autoriza == false || this.autoriza == undefined
                                        && this.checkAuthorization == false){

                                            this.verificaHorario = true
                                        }
                                })
                        }
                    })

            }

            if(this.itemSelecionado.controleJornadaId == this.enums.tipoControleJornada.EXAME){

                this.jornadas.filter(item => moment(item.data, 'DD/MM/YYYY').format('YYYY-MM-DD') == moment(this.itemSelecionado.data, 'DD/MM/YYYY').format('YYYY-MM-DD')

                    && item.horaInicial <= this.horarioAtendimento && item.horaFim >= this.horarioAtendimento
                    && item.profissionalId == this.itemSelecionado.profissionalId).map(verificaTipoExame => {

                        if(verificaTipoExame.tipoId == this.enums.tipoJornada.DINAMICA){

                                const dataAgendamento = moment(verificaTipoExame.data, 'DD/MM/YYYY').format('YYYY-MM-DD');

                                this.verificaVagas = false

                                if(this.exames.length > 1){

                                    this.verificaVagas = true
                                }

                                this.verificaHorario = false

                                this.vagas.filter(item => item.horaExame === this.horarioAtendimento
                                    && dataAgendamento === moment(item.data, 'DD/MM/YYYY').format('YYYY-MM-DD')).map(dinamico => {

                                    if(dinamico){

                                        this.verificaHorario = true
                                    }
                                })
                        } else {

                            this.jornadas.filter(item => moment(item.data, 'DD/MM/YYYY').format('YYYY-MM-DD') == moment(this.itemSelecionado.data, 'DD/MM/YYYY').format('YYYY-MM-DD')
                                && item.horaInicial == this.horarioAtendimento
                                && item.profissionalId == this.itemSelecionado.profissionalId)
                                    .find(fixo => {

                                        let vagasPreenchidas = 0

                                        this.verificaHorario = false
                                        this.verificaVagas = false

                                        const dataAgendamento = moment(fixo.data, 'DD/MM/YYYY').format('YYYY-MM-DD');

                                        this.vagas.filter(item => item.horaExame === this.horarioAtendimento
                                            && moment(item.data, 'DD/MM/YYYY').format('YYYY-MM-DD') === dataAgendamento)
                                                .map(exameIncluido => {

                                                    vagasPreenchidas = vagasPreenchidas + exameIncluido.incluido.length
                                                })

                                        const vagas = Number(fixo.vagas || 0) + Number(fixo.vagasApp || 0)

                                        vagasPreenchidas = vagasPreenchidas + this.exames.length

                                        const vagasDisponiveis = vagas - vagasPreenchidas

                                        if(vagasDisponiveis < 0 && this.autoriza == false || this.autoriza == undefined
                                            && this.checkAuthorization == false){

                                                this.verificaHorario = true
                                                this.verificaVagas = false
                                            }
                                    })

                            let vagasTotal = 0

                            this.jornadas.filter(item => moment(item.data, 'DD/MM/YYYY').format('YYYY-MM-DD') === moment(this.itemSelecionado.data, 'DD/MM/YYYY').format('YYYY-MM-DD')
                                && item.profissionalId == this.itemSelecionado.profissionalId)
                                    .forEach(fixo => {
                                        vagasTotal += Number(fixo.vagas || 0) + Number(fixo.vagasApp || 0)
                                    })

                            let vagasPreenchidas = 0

                            this.vagas.filter(item => moment(item.data, 'DD/MM/YYYY').format('YYYY-MM-DD') === moment(this.itemSelecionado.data, 'DD/MM/YYYY').format('YYYY-MM-DD'))
                                .forEach(exameIncluido => {
                                    vagasPreenchidas += exameIncluido.incluido.length
                                })

                            vagasPreenchidas += this.exames.length

                            const vagasDisponiveis = vagasTotal - vagasPreenchidas

                            if ((vagasDisponiveis < 0) 
                                && ((this.autoriza === false || this.autoriza === undefined) 
                                && this.checkAuthorization === false)) {

                                    this.verificaVagas = true
                            } else {

                                    this.verificaVagas = false
                            }
                        }
                    })
            }

            if (this.verificaHorario && !this.autoriza && !this.checkAuthorization) {

                const confirmar = async () => {
                    this.$refs.RkmModalPermissao.open();

                    return false;
                };

                const cancelar = async () => { };

                const mensagem = `Não foi possível incluir esse exame, pois quantidade de `
                + ` vagas foi atingida para o horário das <strong>${this.horarioAtendimento}</strong>,
                para continuar é necessário informar os` +
                ` dados do supervisor. Deseja continuar?`;

                this.showConfirmation(mensagem, confirmar, cancelar);
                return false;
            }

            if (this.verificaVagas && !this.autoriza && !this.checkAuthorization) {

                const confirmar = async () => {
                    this.$refs.RkmModalPermissao.open();

                    return false;
                };

                const cancelar = async () => { };

                const mensagem = `Quantidade de exame maior que a quantidade de vagas disponível, para continuar é ` +
                ` necessário informar os dados do supervisor. Deseja continuar?`;

                this.showConfirmation(mensagem, confirmar, cancelar);
                return false;
            }

            this.jornada = this.itemSelecionado.jornadaId

            this.$emit('handleAgendamento', this.exames, this.itemSelecionado, this.horarioAtendimento, this.jornada)

            this.$refs.RkmModalExames.hide()
        },
        saveModal(supervisorId){

            this.agendamento.supervisorId = supervisorId
            this.autoriza = true
        },
        getStringDiaSemana(dia) {

            if(dia == this.enums.diasSemana.DOMINGO){
               return 'DOMINGO'

            } else if (dia == this.enums.diasSemana.SEGUNDA_FEIRA){
               return 'SEGUNDA-FEIRA'

            } else if (dia == this.enums.diasSemana.TERCA_FEIRA){
               return 'TERÇA-FEIRA'

            } else if (dia == this.enums.diasSemana.QUARTA_FEIRA){
               return 'QUARTA-FEIRA'

            } else if (dia == this.enums.diasSemana.QUINTA_FEIRA){
               return 'QUINTA-FEIRA'

            } else if (dia == this.enums.diasSemana.SEXTA_FEIRA){
               return 'SEXTA-FEIRA'

            } else if (dia == this.enums.diasSemana.SABADO){
               return 'SÁBADO'
            }
        },
    },
      props: {
        data: { type: Object, required: true },
        agendamento: { type: Object, required: true },
        vagas: { type: Array, required: true },
        horaSave: { type: String, default: null },
        jornadas: { type: Array, required: true },
    },
    mixins: [ error, repository ],
}
</script>